document.querySelectorAll('media-gallery img')?.forEach(function(i){
    i.addEventListener('click', function(e){
        e.preventDefault();        
    })
})
function updateCartAttribute(attributeName, attributeValue) {
    // Get current cart attributes
    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            // Update the attribute
            let attributes = cart.attributes || {};
            attributes[attributeName] = attributeValue;

            // Send updated attributes to Shopify
            fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    attributes: attributes
                })
            })
            .then(response => response.json())
            .then(cart => {
                setTimeout(function(){
                  window.Route?.Protection.render({
                    theming: {
                      mode: window.Route.Theme.Mode.DarkMode,
                      alignment: window.Route.Theme.Alignment.Left
                    }
                  });
                    
                }, 1000)
                console.log('Cart updated:', cart);
                // Optionally, you can add code here to update the UI or provide feedback to the user
            })
            .catch(error => {
                console.error('Error updating cart:', error);
            });
        })
        .catch(error => {
            console.error('Error fetching cart:', error);
        });
}

$(document).on('change', '[name="attributes[Dropshipping]"]', function(d){
    if(d.target.value == 'Yes'){
       updateCartAttribute('Dropshipping', 'Yes') 
    }else{
        updateCartAttribute('Dropshipping', 'No')
    }
})

//  // Attach click event listeners
// $(document).ready(function() {
//     $('.mega-menu-main-nav-item').click(function(event) {
//         event.preventDefault();
//         console.log('Mega menu item clicked!', $(this).attr('href'));
//     });

//     // Attach hover event to trigger click
//     $('.mega-menu-main-nav-item').hover(
//         function() {
//             $(this).trigger('click');
//         },
//         function() {
//             // Optionally handle mouse leave event
//         }
//     );

//     // Ensure SVG click triggers parent click
//     $('svg.icon.icon-angle').click(function(e) {
//         e.preventDefault();
//         $(this).closest('a').trigger("click");
//         return false;
//     });
// });


document.querySelectorAll('mega-menu-main').forEach(function(menu){
    menu.addEventListener('mouseenter', function(){
        menu.setAttribute('aria-expanded', "true")
    })
});
document.querySelectorAll('mega-menu-main').forEach(function(menu){
    menu.addEventListener('mouseleave', function(){
        menu.setAttribute('aria-expanded', "false");
    })
});

function handleize(str) {
    return str
        .toLowerCase()
        .replace(/[^a-z0-9\s]/g, '')
        .trim()
        .replace(/\s+/g, '-');
}

// var class_name = ``;
// document.querySelectorAll('variant-selects select').forEach(function (select) {
//     var option_name = select.getAttribute('name').replaceAll('options[', '').replaceAll(']', '');
//     var option_value = select.value;
//     class_name += `.${handleize(option_name)}-${handleize(select.value)}`
//     // console.log(`${handleize(option_name)}-${handleize(select.value)}`);
// });
// console.log(class_name);

subscribe(PUB_SUB_EVENTS.productVariantChange, (data) => {
    var class_name = ``;
    document.querySelectorAll('variant-selects select').forEach(function (select) {
        var option_name = select.getAttribute('name').replaceAll('options[', '').replaceAll(']', '');
        var option_value = select.value;
        class_name += `.${handleize(option_name)}-${handleize(select.value)}`
        // console.log(`${handleize(option_name)}-${handleize(select.value)}`);
    });
    document.querySelectorAll('.product-media-thumbnails .product-media-thumbnail').forEach(function(thumb){
        thumb.classList.add('hidden');
    });
    if(document.querySelectorAll(`.product-media-thumbnails .product-media-thumbnail${class_name}`).length){
        document.querySelectorAll(`.product-media-thumbnails .product-media-thumbnail${class_name}`).forEach(function(thumb){
            thumb.classList.remove('hidden');
        });
        document.querySelectorAll(`.product-media-thumbnails .product-media-thumbnail.show-for-all`).forEach(function(thumb){
            thumb.classList.remove('hidden');
        });
    }else{
        document.querySelectorAll('.product-media-thumbnails .product-media-thumbnail').forEach(function(thumb){
            thumb.classList.remove('hidden');
        });
    }
});
publish(PUB_SUB_EVENTS.productVariantChange)